(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spark-comparador"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spark-comparison')) {
    customElements.define('spark-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const range = this.querySelector('input');
        const update = () => {
          this.style.setProperty('--reveal', range.value + '%');
          this.querySelector('.spark-comparison__label--after').style.visibility = Number(range.value) < 15 ? 'hidden' : 'visible';
          this.querySelector('.spark-comparison__label--before').style.visibility = Number(range.value) > 85 ? 'hidden' : 'visible';
        };
        range.addEventListener('input', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spark-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spark-contact')) {
    customElements.define('spark-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        const body = this.querySelector('[data-contact-body]');
        const commune = this.querySelector('[data-contact-commune]');
        const otherField = this.querySelector('[data-contact-other-field]');
        const otherCommune = this.querySelector('[data-contact-other-commune]');
        if (!body || !commune) return;
        const params = new URLSearchParams(window.location.search);
        const clean = (key) => (params.get(key) || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 180);
        const selectedCommune = clean('comuna');
        if (!commune.value && selectedCommune) {
          const match = Array.from(commune.options).find((option) => option.value.toLocaleLowerCase('es') === selectedCommune.toLocaleLowerCase('es'));
          commune.value = match ? match.value : 'otra';
        }
        if (otherField && otherCommune) {
          const syncOtherCommune = () => {
            const isOther = commune.value === 'otra';
            otherField.hidden = !isOther;
            otherCommune.disabled = !isOther;
            otherCommune.required = isOther;
            otherCommune.setAttribute('aria-required', String(isOther));
          };
          const generalOtherLabels = ['otra', 'otra comuna', 'other', 'another municipality'];
          if (commune.value === 'otra' && !otherCommune.value.trim() && selectedCommune && !generalOtherLabels.includes(selectedCommune.toLocaleLowerCase('es'))) {
            otherCommune.value = selectedCommune.slice(0, 120);
          }
          commune.addEventListener('change', syncOtherCommune);
          syncOtherCommune();
        }
        if (body.value.trim()) return;
        const fields = [
          ['servicio', this.dataset.serviceLabel],
          ['comuna', this.dataset.communeLabel],
          ['fecha', this.dataset.dateLabel],
          ['hora', this.dataset.timeLabel],
          ['vehiculo', this.dataset.vehicleLabel]
        ];
        const lines = fields.map(([key, label]) => {
          const value = clean(key);
          return value ? `${label}: ${value}` : '';
        }).filter(Boolean);
        const reasons = { evaluacion: this.dataset.reasonEvaluation, cobertura: this.dataset.reasonCoverage };
        const reason = clean('motivo').split(',').map(key => reasons[key.trim()]).filter(value => typeof value === 'string' && value).join('; ');
        if (reason) lines.unshift(`${this.dataset.reasonLabel}: ${reason}`);
        if (lines.length) body.value = `${this.dataset.summaryIntro}\n\n${lines.join('\n')}\n\n`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
